@if (isPresenter()) {
  <div class="total-time">
    <p>Total:</p>
    <ninety-clock-timer [totalSeconds]="timers().meetingTime" />
    @if (showCountdown()) {
      <div class="countdown">{{ sectionSecondsRemaining() }}</div>
    }
  </div>
  <div class="progress-bar-timer">
    <mat-progress-bar
      mode="determinate"
      [value]="timers().progressBarValue"
      [color]="isSectionOvertime() ? 'warn' : 'accent'" />
    @if (timers().navigationEnded) {
      <ninety-clock-timer [totalSeconds]="timers().sectionTime" [totalTimeAllotted]="timers().sectionDuration" />
    }
  </div>
  <div class="meeting-controls" role="group" aria-label="Meeting controls">
    <ninety-button flat icon ariaLabel="Back to previous section" (click)="sectionSkipped.emit(false)">
      <terra-icon icon="skip-back" variant="fill" size="12" />
    </ninety-button>
    <ninety-button flat icon [ariaLabel]="isPaused() ? 'Resume' : 'Pause'" (click)="pauseToggled.emit()">
      @if (isPaused()) {
        <terra-icon icon="play" variant="fill" size="12" />
      } @else {
        <terra-icon icon="pause" variant="fill" size="12" />
      }
    </ninety-button>
    <ninety-button flat icon ariaLabel="Skip to next section" (click)="sectionSkipped.emit(true)">
      <terra-icon icon="skip-forward" variant="fill" size="12" />
    </ninety-button>
    <ninety-button secondary flat class="suspend-btn uppercase" [disabled]="suspending()" (click)="suspended.emit()">
      Suspend
    </ninety-button>
  </div>
} @else {
  <div class="meeting-controls">
    <ninety-button flat class="leave-btn" (click)="attendeeLeft.emit()">
      <span>Leave {{ meetingItemLabel() }}</span>
      <terra-icon icon="sign-in" />
    </ninety-button>
  </div>
}
